import { PropertySet } from '@miq/domain/property-sets';
import { EntityType } from '@miq/domain';
import { User } from '@miq/user';

export enum PropertySetMode {
  View = 'view',
  Manage = 'manage',
}

export interface PropertySetsFilters {
  markets?: string[];
  property_types?: string[];
  level?: number[];
}

/**
 * Contains the data to be passed to the PropertySetsDialogComponent. The data contains the following properties:
 * - ids - The list of record ids to be added to a given property set and the mode of the dialog.
 * - The mode of the dialog. The 'edit' mode is used to add records to a property set
 *    user can only see or select property sets for which he is the owner OR has been granted access by user/role.
 *    in 'edit' mode, user can also manipulate the selected property-set metadata and remove or add records (beyond
 *    the ones passed in the records array, by searching).
 *    whereas the 'manage' mode is used to manage the records of a property set.
 * - The target property type - the property type of the records to be added to the property set AND pre-populate
 *    the property set target property type filter.
 */
export interface PropertySetDialogData {
  /**
   * entity of dialog
   */

  entity: EntityType;
  /**
   * The mode of the dialog.
   */
  dialogMode: PropertySetMode;
  /**
   * The list of records to be added to a given property set.
   */
  ids?: number[];
  /**
   * Initial/Seed values to perform filters
   */
  filters?: PropertySetsFilters;
  /**
   * user data.
   */
  userInfo?: User;

  source?: string;
}

export enum PropertySetView {
  List = 'list',
  Details = 'details',
}

export enum PropertySetDetailsMode {
  Read = 'read',
  Edit = 'edit',
}

/**
 * Contains the state of the property sets dialog.
 */
export interface PropertySetsState extends PropertySetDialogData {
  view?: PropertySetView;
  mode?: PropertySetDetailsMode;
  hasBackButton?: boolean;
  id?: number;
  dirty?: boolean;
  valid?: boolean;
  propertySet?: PropertySet;
  propertySetChange?: PropertySet;
  removedRecords?: number[];
  addedRecords?: number[];
  externalUsageType?: string;
}
